<template>
    <div class="viewing-discipline-section">
           <el-form label-position="top" ref="form" :model="form" label-width="120px">
            <el-form-item size="mini" label="Дисциплина">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item size="mini" label="URL вебинара">
                <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item size="mini" label="Тема">
                <el-input v-model="form.theme"></el-input>
            </el-form-item>
            <!-- <el-form-item size="mini" label="Продолжительность">
                <el-input v-model="form.duration"></el-input>
            </el-form-item>
            <el-form-item size="mini" label="Дата">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="Pick a date" v-model="form.date1" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2"></el-col>
                <el-col :span="11">
                    <el-time-picker placeholder="Pick a time" v-model="form.date2" style="width: 100%;"></el-time-picker>
                </el-col>
            </el-form-item> -->
            <el-form-item>
                <el-button size="mini" type="primary" @click="onSubmit">Create</el-button>
                <el-button size="mini">Cancel</el-button>
            </el-form-item>
            </el-form>
        <el-row>
            <el-col class="video-tree" :span="24">
                <tree-item class="discipline-item" :item="videosObj"/>
            </el-col>
        </el-row>
    </div>
</template>

<script>

import {bus} from '../../main'
import { mapMutations } from 'vuex'
export default {
    data() {
        return {
            form: {
                name: '',
                url: '',
            },
            videosObj:{
              id:0,
              execution:'video-tree',
              level:0,
              lable: this.title,
              children: [],
              path: 'content',
              type:'directory',
              videos: [],
              webinars: []
          }
        }
    },
    props:{
        componentData: Object,
        title: String

    },
    components:{
        'tree-item':() => import('../viewingDiscipline/itemTree'),
    },
    computed:{
        pathTest(){
            if(this.selectedItem){
                return this.selectedItem.path
            }else{
                return ''
            }
        },
        showMenu(){
           return this.$store.state.viewingDiscipline.selectedItem
        },
        blockSubmit(){
            return this.form.name && (this.form.url || this.selectedItem) ? false : true
        },
        selectedItem(){
            return this.$store.state.viewingDiscipline.selectedItem
        },
        blockUrlField(){
            return this.selectedItem ? true : false
        },
        blockNameField(){
            return this.componentData ? true : false
        }

    },
    methods: {
        ...mapMutations(['setSelectedItem', 'updateVideoTree']),
        clearFields(item){
            for (var key in item) {
                item[key]=''
            }
        },
        
        cancelChange(data){
            if(data){
                this.form.name = data.name
                this.form.url = data.url
            }else{
                this.form.name = data.name
                this.form.url = data.url
                this.setSelectedItem(null)
            }
        },
        onSubmit(flag) {
            let obj={name:this.form.name}
            if(this.selectedItem){
                obj.path = this.selectedItem.path
            }else{
                if(!this.checkURl(this.form.url)){
                    return this.notify(false, 'Указанная ссылка некорректна')
                }else{
                    obj.url = this.form.url
                }
            }
            flag === 'add' ? this.addVideo(obj) : this.editVideo(obj) 
        },
        editVideo(obj){
            this.axios.patch(`api/disciplines/${this.$route.params.did}/videos/${this.componentData.id}`, obj)
            .then(res=>{
                if(res.data.status){
                    this.form.url = res.data.video.url
                    this.updateVideoTree(res.data.videoMap)
                    this.setSelectedItem(null)
                }
                this.notify(res.data.status, res.data.message)
            })
        },
        addVideo(obj){
            this.axios.post(`api/disciplines/${this.$route.params.did}/videos`, obj)
            .then(res=>{
                if(res.data.status){
                    this.clearFields(this.form)
                    this.updateVideoTree(res.data.videoMap)
                    this.setSelectedItem(null)
                }
                this.notify(res.data.status, res.data.message)
            })
        },
        checkURl(value){
            let re = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;
            let reResult = re.test(value)
            return reResult
        },
        notify(status, text){
            const h = this.$createElement
            this.$notify({
                title: '',
                message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
            });
        }
    },
    mounted() {
        this.axios.get(`api/disciplines/${this.$route.params.did}/v-store`)
            .then(res=>{
                this.videosObj.children = res.data.menu
            })
        if(this.componentData){
            this.form.url = this.componentData.url
            this.form.name = this.componentData.name
        }
    },
    beforeDestroy(){
        this.setSelectedItem(null)
    }
}
</script>

<style lang="scss">
    .viewing-discipline-section{
       .el-form{
           .el-form-item__label{
               padding-bottom: 0;
           }
       }
    }
</style>